<template lang="pug">
.compare-shades-tool.container(v-if="loaded" )
  .row.title-wrap.text-center
    h1.normal.sm-f-xlarge.md-f-xxlarge.max-at-tweak {{ textH1 }}
  .row.shade-selector
    .shade-dropdown
      .swatches(@click="startDropdown = !startDropdown" :class="{open: startDropdown, selected: !!selectedLevel}", data-mr-ass="swatch-dropdown")
        .start-swatch(v-if="!selectedLevel")
          p.header.semi-bold.font-xsmall choose color
        .selected-swatch(v-if="selectedLevel")
          img(:src="selectedSwatch.url", :alt="selectedSwatch.alt_text", v-if="selectedSwatch")

          p.header.sem-bold.color-white.font-xsmall {{ lightDarkText }}

        .swatch(@click="selectLevel(2)")
          img(:src="swatchLevel2.url", :alt="swatchLevel2.alt_text")
          p.header.semi-bold.color-white.font-xsmall level 2
        .swatch(@click="selectLevel(3)")
          img(:src="swatchLevel3.url" :alt="swatchLevel3.alt_text")
          p.header.semi-bold.color-white.font-xsmall level 3
        .swatch(@click="selectLevel(4)")
          img(:src="swatchLevel4.url" :alt="swatchLevel4.alt_text")
          p.header.semi-bold.color-white.font-xsmall level 4
        .swatch(@click="selectLevel(5)")
          img(:src="swatchLevel5.url" :alt="swatchLevel5.alt_text")
          p.header.semi-bold.color-white.font-xsmall level 5
        .swatch(@click="selectLevel(6)")
          img(:src="swatchLevel6.url" :alt="swatchLevel6.alt_text")
          p.header.semi-bold.color-white.font-xsmall level 6
        .swatch(@click="selectLevel(7)")
          img(:src="swatchLevel7.url" :alt="swatchLevel7.alt_text")
          p.header.semi-bold.color-white.font-xsmall level 7
        .swatch(@click="selectLevel(8)")
          img(:src="swatchLevel8.url" :alt="swatchLevel8.alt_text")
          p.header.semi-bold.color-white.font-xsmall level 8
        .swatch(@click="selectLevel(9)")
          img(:src="swatchLevel9.url" :alt="swatchLevel9.alt_text")
          p.header.semi-bold.color-white.font-xsmall level 9
        .swatch(@click="selectlevel(10)")
          img(:src="swatchLevel10.url" :alt="swatchLevel10.alt_text")
          p.header.semi-bold.color-white.font-xsmall level 10
        .swatch(@click="selectLevel(11)")
          img(:src="swatchLevel11.url" :alt="swatchLevel11.alt_text")
          p.header.semi-bold.color-white.font-xsmall level 11

        .arrow

    div(v-if="selectedLevel")
      #shades-wrap.fixed-width-tweak-upper
        .shades-in-level.xs-f-small.md-f-medium.lg-f-small.max-at-tweak(:class="shadesInLevelClass" )
          slick.shades-carousel(ref="slick" :autoplay="false" :infinite="false" :arrows="false" :variable-width="true" :slides-to-show="5" :responsive="[ { breakpoint: 960, settings: { slidesToShow: 4 } }, { breakpoint: 560, settings: { slidesToShow: 3} } ]" )
            ProductSlide(v-for="product in selectedLevel.products" @select="selectShade(product)" @deselect="clearProduct(product)" :key="product.urlKey" :product="product" :isBestMatch="isBestMatch(product)" :isOtherMatch="isOtherMatch(product)" :showCheckIcon="showCheckIcon(product)")
          .left-nav.text-left.clickable
            p.upper.light.color-mr-purple.xs-f-xsmall.md-f-small.lg-f-xsmall.max-at-tweak(@click="goPrev") &lt; warmer
          .right-nav.text-right.clickable
            p.upper.light.color-mr-purple.xs-f-xsmall.md-f-small.lg-f-xsmall.max-at-tweak(@click="goNext") cooler &gt;

        .simple-shades-in-level.text-center.xs-f-small.md-f-medium.lg-f-small.max-at-tweak(:class="simpleShadesInLevelClass")
          .left-nav-simple.text-left
            p.upper.light.xs-f-xsmall.md-f-small.lg-f-xsmall.max-at-tweak warmer
          ProductSlide(v-for="product in selectedLevel.products" @select="selectShade(product)" @deselect="clearProduct(product)" :key="product.urlKey" :product="product" :isBestMatch="isBestMatch(product)" :isOtherMatch="isOtherMatch(product)" :showCheckIcon="showCheckIcon(product)")
          .right-nav-simple.text-right
            p.upper.light.xs-f-xsmall.md-f-small.lg-f-xsmall.max-at-tweak cooler

  .row.shade-comparer.text-center.xs-f-small.md-f-medium.lg-f-small.max-at-tweak
    .xs-12
      .fixed-width-tweak-upper
        SelectedProduct(:selectedProduct="selectedOne" @selected="selectedOne = null" @notRecommended="notRecommendModal(selectedOne)" clazz="one" :isBestMatch="isBestMatch(selectedOne)" :isOtherMatch="isOtherMatch(selectedOne)")
        SelectedProduct(:selectedProduct="selectedTwo" @selected="selectedTwo = null" @notRecommended="notRecommendModal(selectedTwo)" clazz="two" :isBestMatch="isBestMatch(selectedTwo)" :isOtherMatch="isOtherMatch(selectedTwo)")

    CompareTips(v-if="showCompareTips" :productOne="selectedOne" :productTwo="selectedTwo" :tips="tips")

</template>
<script>
  import { mapActions } from 'vuex';
  import vueAdvisorSvc from '@services/vueAdvisorSvc';
  import vueQuizSvc from '@services/vueQuizSvc';
  import ImgBox from '@components/imgBox';
  import SelectedProduct from './SelectedProduct.vue';
  import CompareTips from './CompareTips.vue';
  import ProductSlide from './ProductSlide.vue';

  export default {
    name: 'CompareShadesTool',
    components: {
      ImgBox,
      SelectedProduct,
      CompareTips,
      ProductSlide,
    },
    inject: ['getObjProperty'],
    props: {
      swatchLevel2: { type: Object, default: () => ({}) },
      swatchLevel3: { type: Object, default: () => ({}) },
      swatchLevel4: { type: Object, default: () => ({}) },
      swatchLevel5: { type: Object, default: () => ({}) },
      swatchLevel6: { type: Object, default: () => ({}) },
      swatchLevel7: { type: Object, default: () => ({}) },
      swatchLevel8: { type: Object, default: () => ({}) },
      swatchLevel9: { type: Object, default: () => ({}) },
      swatchLevel10: { type: Object, default: () => ({}) },
      swatchLevel11: { type: Object, default: () => ({}) },
      textH1: { type: String, default: () => '' },
      naturalTooDarkText: { type: String, default: () => '' },
      naturalTooLightText: { type: String, default: () => '' },
      treatedTooDarkText: { type: String, default: () => '' },
      treatedTooLightText: { type: String, default: () => '' },
      highLiftWithHighlightsText: { type: String, default: () => '' },
      hotRootsText: { type: String, default: () => '' },
      sectionHeader: { type: String, default: () => '' },
      showCompareTips: Boolean,
      nnn: { type: String, default: () => '' },
      ngvVsCooler: { type: String, default: () => '' },
      coolVsSameLighter: { type: String, default: () => '' },
      fallback: { type: String, default: () => '' },
    },
    data() {
      return {
        loaded: false,
        colorsByLevel: [],
        selectedOne: null,
        selectedTwo: null,
        bestMatch: null,
        otherMatches: null,
        startDropdown: false,
        coolShades: ['NA', 'NAV', 'NVA', 'AV', 'NV', 'VA', 'AA'],
        levels: [2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
        advisorAnswers: null,
        selectedLevel: null,
      };
    },
    computed: {
      shadesInLevelClass() {
        const clazz = [];
        if (!this.selectedLevel) {
          return '';
        }
        if (this.selectedLevel.products.length <= 3) {
          clazz.push('xs-hide');
        }
        if (this.selectedLevel.products.length <= 4) {
          clazz.push('sm-hide', 'md-hide');
        }
        if (this.selectedLevel.products.length <= 6) {
          clazz.push('lg-hide');
        }
        return clazz.join(' ');
      },
      simpleShadesInLevelClass() {
        // {'xs-hide': shadesInLevel > 3, 'sm-hide': shadesInLevel > 4, 'md-hide': shadesInLevel > 4, 'lg-hide': shadesInLevel > 6}
        const clazz = [];
        if (!this.selectedLevel) {
          return '';
        }
        if (this.selectedLevel.products.length > 3) {
          clazz.push('xs-hide');
        }
        if (this.selectedLevel.products.length > 4) {
          clazz.push('sm-hide', 'md-hide');
        }
        if (this.selectedLevel.products.length > 6) {
          clazz.push('lg-hide');
        }
        return clazz.join(' ');
      },
      notRecommendations() {
        return {
          naturalTooDark: {
            text: 'Natural hair',
            content: this.naturalTooDarkText,
          },
          naturalTooLight: {
            text: 'Natural hair',
            content: this.naturalTooLightText,
          },
          treatedTooDark: {
            text: 'Color-treated hair',
            content: this.treatedTooDarkText,
          },
          treatedTooLight: {
            text: 'Color-treated hair',
            content: this.treatedTooLightText,
          },
          hotRoots: {
            text: 'Color-treated hair',
            content: this.hotRootsText,
          },
        };
      },
      tips() {
        return {
          nnn: this.nnn,
          ngvVsCooler: this.ngvVsCooler,
          coolVsSameLighter: this.coolVsSameLighter,
          fallback: this.fallback,
        };
      },
      selectedSwatch() {
        if (this.selectedLevel) {
          const swatchKey = `swatchLevel${this.selectedLevel.level}`;
          if (this[swatchKey]) {
            return this[swatchKey];
          }
        }
        return null;
      },
      lightDarkText() {
        const level = this.selectedLevel.level;
        let text = `level ${level} - `;
        if (this.levels.indexOf(level) === 0) {
          text += 'see lighter';
        } else if (this.levels[this.levels.length - 1] === level) {
          text += 'see darker';
        } else {
          text += 'see lighter or darker';
        }
        return text;
      },
    },
    async mounted() {
      const res = await vueAdvisorSvc.getCompareShadesData();
      this.colorsByLevel = res.data.colorsByLevel;
      this.bestMatch = res.data.bestMatch;
      this.otherMatches = res.data.otherMatches;

      const advisorRes = await vueQuizSvc.getCustomerAnswers();
      this.advisorAnswers = advisorRes;

      this.loaded = true;
    },
    methods: {
      ...mapActions('modal', ['showModal']),
      notRecommendModal(product) {
        this.showModal({
          component: 'NotRecommendedModal',
          props: {
            product,
            notRecommendations: this.notRecommendations,
          },
        });
      },
      selectLevel(l) {
        this.selectedLevel = this.colorsByLevel.find(level => level.level == l);
      },
      goPrev() {
        this.$refs.slick.prev();
      },
      goNext() {
        this.$refs.slick.next();
      },
      isOtherMatch(product) {
        return product && this.otherMatches && this.otherMatches[product.color_designator];
      },
      isBestMatch(product) {
        return product && product.color_designator == this.bestMatch;
      },
      showCheckIcon(product) {
        return this.isProductSelected(product);
      },
      isProductSelected(product) {
        return (
          this.getObjProperty(this, 'selectedOne.color_designator') == product.color_designator ||
          this.getObjProperty(this, 'selectedTwo.color_designator') == product.color_designator
        );
      },
      clearProduct(product) {
        if (this.getObjProperty(this, 'selectedOne.code') == product.code) {
          this.selectedOne = null;
        } else if (this.getObjProperty(this, 'selectedTwo.code') === product.code) {
          this.selectedTwo = null;
        }
      },
      checkIfShadeIsCool(product) {
        const productShade = product.color_designator;
        for (let shade of this.coolShades) {
          if (productShade.substring(productShade.length - shade.length, productShade.length) == shade) {
            return true;
          }
        }
        return false;
      },
      checkCompareTip(prodOne, prodTwo, color_designator) {
        return ~prodOne.color_designator.indexOf(color_designator) && !~prodTwo.color_designator.indexOf(color_designator);
      },
      checkCoolCompareTip(prodOne, prodTwo) {
        return prodOne.isCool && !prodTwo.isCool && prodOne.level >= this.advisorAnswers.natural_hair_shade;
      },
      selectShade(product) {
        if (!this.selectedOne) {
          this.selectedOne = product;
        } else {
          this.selectedTwo = product;
        }

        if (this.selectedOne) {
          this.selectedOne.compareTip = '';
        }

        if (this.selectedTwo) {
          this.selectedTwo.compareTip = '';
        }

        if (this.selectedOne && this.selectedTwo) {
          this.$set(this.selectedOne, 'isCool ', this.checkIfShadeIsCool(this.selectedOne));
          this.$set(this.selectedTwo, 'isCool ', this.checkIfShadeIsCool(this.selectedTwo));

          if (this.checkCompareTip(this.selectedOne, this.selectedTwo, 'NNN')) {
            this.$set(this.selectedOne, 'compareTip', 'nnn');
          } else if (this.checkCompareTip(this.selectedTwo, this.selectedOne, 'NNN')) {
            this.$set(this.selectedTwo, 'compareTip', 'nnn');
          }

          if (this.checkCompareTip(this.selectedOne, this.selectedTwo, 'NGV')) {
            this.$set(this.selectedOne, 'compareTip', 'ngvVsCooler');
          } else if (this.checkCompareTip(this.selectedTwo, this.selectedOne, 'NGV')) {
            this.$set(this.selectedTwo, 'compareTip', 'ngvVsCooler');
          }

          if (this.checkCoolCompareTip(this.selectedOne, this.selectedTwo)) {
            this.$set(this.selectedOne, 'compareTip ', 'coolVsSameLighter');
          } else if (this.checkCoolCompareTip(this.selectedTwo, this.selectedOne)) {
            this.$set(this.selectedTwo, 'compareTip ', 'coolVsSameLighter');
          }

          this.scrollTo('#shades-wrap', null, null);

          if (this.getObjProperty(this, 'selectedOne.compareTip') || this.getObjProperty(this, 'selectedTwo.compareTip')) {
            this.trackEvent('Compare Shades Product Tip', {
              productOneId: this.selectedOne.id,
              productOneName: this.selectedOne.name,
              productOneTip: this.selectedOne.compareTip || '',
              productTwoId: this.selectedTwo.id,
              productTwoName: this.selectedTwo.name,
              productTwoTip: this.selectedTwo.compareTip || '',
            });
          }
        }
      },
    },
  };
</script>
<style lang="stylus">
  .compare-shades-tool
    .img.text-center
      max-width 126px
      @media mq-mobile
        max-width 111px
</style>